import React from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <div className="min-h-screen bg-black py-24 px-6">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-[#121214] border border-white/10 rounded-2xl p-8 md:p-12"
        >
          <h1 className="text-4xl sm:text-5xl font-medium mb-6 tracking-tight">Contact Us</h1>
          <div className="prose prose-invert max-w-none">
            <div className="space-y-6 text-[#A1A1A6] leading-relaxed">
              <p className="text-lg">
                We're here to help! Whether you have questions about our services, need assistance with your account, want to report an issue, or have feedback to share, we're always ready to listen and assist you.
              </p>

              <div className="bg-[#0A0A0B] p-8 rounded-xl border border-white/10 my-8">
                <h2 className="text-2xl font-medium text-white mb-6">Get in Touch</h2>
                
                <div className="space-y-6">
                  <div>
                    <h3 className="text-lg font-medium text-white mb-2">Email</h3>
                    <a href="mailto:mygaadinumber@gmail.com" className="text-[#FF3B30] text-xl font-medium hover:underline">
                      mygaadinumber@gmail.com
                    </a>
                  </div>

                  <div className="border-t border-white/10 pt-6">
                    <h3 className="text-lg font-medium text-white mb-2">Phone Support</h3>
                    <p className="text-[#FF3B30] text-xl font-medium">+91 9014556536</p>
                    <p className="text-sm text-[#86868B] mt-1">Available Monday to Saturday, 9:00 AM - 6:00 PM IST</p>
                  </div>

                  <div className="border-t border-white/10 pt-6">
                    <h3 className="text-lg font-medium text-white mb-2">Business Address</h3>
                    <p className="text-white">
                      <strong>MyGaadiNumber</strong><br />
                      Door No. 302, Chaimina Enclave<br />
                      AS Raju Nagar, Kukatpally<br />
                      Hyderabad, Telangana - 500072<br />
                      India
                    </p>
                  </div>
                </div>
              </div>

              <h2 className="text-2xl font-medium text-white mt-12 mb-4">What Can We Help You With?</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-8">
                <div className="bg-[#0A0A0B] p-6 rounded-xl border border-white/10">
                  <h3 className="text-lg font-medium text-white mb-3">Account Support</h3>
                  <ul className="list-disc pl-5 space-y-2 text-sm">
                    <li>Registration assistance</li>
                    <li>Login issues</li>
                    <li>Password recovery</li>
                    <li>Profile update help</li>
                    <li>Account deletion requests</li>
                  </ul>
                </div>

                <div className="bg-[#0A0A0B] p-6 rounded-xl border border-white/10">
                  <h3 className="text-lg font-medium text-white mb-3">Payment & Billing</h3>
                  <ul className="list-disc pl-5 space-y-2 text-sm">
                    <li>Payment gateway queries</li>
                    <li>Transaction issues</li>
                    <li>Referral code problems</li>
                    <li>Wallet withdrawal requests</li>
                    <li>Payment receipt requests</li>
                  </ul>
                </div>

                <div className="bg-[#0A0A0B] p-6 rounded-xl border border-white/10">
                  <h3 className="text-lg font-medium text-white mb-3">Technical Issues</h3>
                  <ul className="list-disc pl-5 space-y-2 text-sm">
                    <li>Website not loading</li>
                    <li>Search functionality problems</li>
                    <li>Photo upload issues</li>
                    <li>Browser compatibility</li>
                    <li>Mobile access problems</li>
                  </ul>
                </div>

                <div className="bg-[#0A0A0B] p-6 rounded-xl border border-white/10">
                  <h3 className="text-lg font-medium text-white mb-3">Reports & Complaints</h3>
                  <ul className="list-disc pl-5 space-y-2 text-sm">
                    <li>Spam reports</li>
                    <li>Abuse or misuse</li>
                    <li>False information reports</li>
                    <li>Privacy concerns</li>
                    <li>Security issues</li>
                  </ul>
                </div>
              </div>

              <h2 className="text-2xl font-medium text-white mt-12 mb-4">Cancellation Queries</h2>
              <p>
                If you wish to cancel your subscription or have questions about our no-refund policy, please contact us at <strong className="text-white">+91 9014556536</strong> or email <a href="mailto:mygaadinumber@gmail.com" className="text-[#FF3B30] hover:underline">mygaadinumber@gmail.com</a>. While we maintain a strict no-refund policy after registration completion (as outlined in our Terms & Conditions), we're happy to discuss your concerns and explore available options.
              </p>

              <div className="text-center mt-12 p-8 bg-[#0A0A0B] rounded-xl border border-white/10">
                <p className="text-2xl font-medium text-white mb-2">Ready to reach out?</p>
                <p className="text-[#FF3B30] text-3xl font-medium mb-4">+91 9014556536</p>
                <a href="mailto:mygaadinumber@gmail.com" className="text-[#FF3B30] text-xl hover:underline">
                  mygaadinumber@gmail.com
                </a>
                <p className="text-sm text-[#86868B] mt-4">
                  We're here to help you make the most of MyGaadiNumber
                </p>
              </div>

              <p className="text-center text-sm text-[#86868B] mt-8">
                Thank you for being part of the MyGaadiNumber community. Together, we're making roads safer, one vehicle at a time.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;